import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Register from "./Register.js";
import UserInfoAbout from "./UserInfoAbout.js";
import UserInfo from "./UesrInfo.js";
import DocumentUpload from "./DocumentUpload.js";
import UserSign from "./UserSign.js";

const SignUp = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const step = searchParams.get("step") || "1";

  const components = {
    1: <Register />,
    2: <UserInfo />,
    3: <UserInfoAbout />,
    4: <DocumentUpload />,
    5: <UserSign />,
  };

  useEffect(() => {
    if (!searchParams.get("step")) {
      setSearchParams({ step: "1" });
    }
  }, [searchParams, setSearchParams]);

  return (
    <>
      {components[step] || <div>Invalid step. Please check the URL.</div>}
    </>
  );
};

export default SignUp;
